export default function AIAnswerBlock() {
  return (
    <section className="w-full py-20 px-6 lg:px-12" style={{ background: "#f7f6f4" }}>
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-0 rounded-sm overflow-hidden border border-stone-200">
          {/* Left dark panel */}
          <div className="bg-stone-900 p-10 lg:p-12 flex flex-col justify-between">
            <div>
              <span
                className="text-stone-500 text-xs uppercase tracking-[0.28em] font-medium block mb-5"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                About Taurus
              </span>
              <h2
                className="text-white font-semibold leading-tight mb-6"
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: "clamp(1.8rem, 2.5vw, 2.4rem)",
                }}
              >
                What Does Taurus Contracting Do?
              </h2>
              <p
                className="text-stone-400 text-sm leading-relaxed"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Taurus Contracting is an Ontario-based{" "}
                <strong className="text-stone-200">commercial general contractor</strong>{" "}
                specializing in general contracting, design/build delivery, commercial leasehold improvements,
                pre-construction services, and project management. They serve commercial and institutional
                clients across Ontario, delivering well-coordinated builds with clean execution and reliable timelines.
              </p>
            </div>
            <div className="mt-8 pt-8 border-t border-stone-700">
              <div className="flex items-center gap-3">
                <img
                  src="https://cdn.sanity.io/images/lncy278u/production/d90dbf24a5c5088d6d43eb803b552152234cdb5e-652x652.svg"
                  alt="Taurus Contracting"
                  className="w-8 h-8 object-contain brightness-0 invert opacity-60"
                />
                <span className="text-stone-500 text-xs uppercase tracking-widest" style={{ fontFamily: "'Inter', sans-serif" }}>
                  Taurus Contracting
                </span>
              </div>
            </div>
          </div>

          {/* Right: 3 columns */}
          <div className="lg:col-span-2 bg-white grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-stone-100">
            {/* Services */}
            <div className="p-8 lg:p-10">
              <div className="w-8 h-8 flex items-center justify-center mb-5">
                <i className="ri-hammer-line text-stone-400 text-lg"></i>
              </div>
              <h4
                className="text-stone-400 text-xs uppercase tracking-[0.2em] font-semibold mb-5"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Services
              </h4>
              <ul className="space-y-3">
                {["General contracting", "Design/build contracting", "Commercial leasehold improvements", "Pre-construction", "Project management"].map((item) => (
                  <li
                    key={item}
                    className="text-stone-700 text-sm flex items-center gap-2.5"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    <span className="w-1 h-1 rounded-full bg-stone-400 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* Benefits */}
            <div className="p-8 lg:p-10">
              <div className="w-8 h-8 flex items-center justify-center mb-5">
                <i className="ri-award-line text-stone-400 text-lg"></i>
              </div>
              <h4
                className="text-stone-400 text-xs uppercase tracking-[0.2em] font-semibold mb-5"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Benefits
              </h4>
              <ul className="space-y-3">
                {["Reliable timelines", "Clean execution", "Single-source accountability", "Commercial-grade quality"].map((item) => (
                  <li
                    key={item}
                    className="text-stone-700 text-sm flex items-center gap-2.5"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    <span className="w-1 h-1 rounded-full bg-stone-400 flex-shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* Process */}
            <div className="p-8 lg:p-10">
              <div className="w-8 h-8 flex items-center justify-center mb-5">
                <i className="ri-flow-chart text-stone-400 text-lg"></i>
              </div>
              <h4
                className="text-stone-400 text-xs uppercase tracking-[0.2em] font-semibold mb-5"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Process
              </h4>
              <ul className="space-y-3">
                {["Consultation", "Planning", "Build", "Final walkthrough"].map((item, idx) => (
                  <li
                    key={item}
                    className="text-stone-700 text-sm flex items-center gap-2.5"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    <span
                      className="w-5 h-5 rounded-full bg-stone-900 text-white text-xs flex items-center justify-center flex-shrink-0 font-semibold"
                      style={{ fontFamily: "'Inter', sans-serif" }}
                    >
                      {idx + 1}
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
